import React from 'react'
import injectSheet from 'react-jss'

class NativeRadioInput extends React.Component {
  render () {
    const {
      classes,
      id,
      name,
      checked,
      onClick,
      onChange,
    } = this.props

    return (
      <div className={classes.radioInputContainer}>
        <input
          type='radio'
          id={id}
          name={name}
          checked={checked}
          onClick={onClick}
          onChange={onChange}
        />
        <label htmlFor={id}>
          <div className={classes.labelContainer}>
            <span />
          </div>
        </label>
      </div>
    )
  }
}

const styles = {
  radioInputContainer: {
    width: 80,
  },
  labelContainer: {
    display: 'inline-block',
    width: '100%',
  },
}

export default injectSheet(styles)(NativeRadioInput)



// WEBPACK FOOTER //
// ./src/components/NativeRadioInput.js